import React from 'react'
import FormularioAhorro from 'components/ahorro/FormularioAhorro'
import Navbar from 'components/generales/Navbar'
import { Outlet } from 'react-router-dom'

const RegistrarAhorro = () => {
  return (
    <>
      <Outlet />
      <Navbar />
      <section>
        <div className="imagenContenedor imagenAhorro"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <h2>Registrar Ahorro</h2>
            <FormularioAhorro />
          </div>
        </div>
      </section>
    </>
  )
}

export default RegistrarAhorro